module.exports = __webpack_public_path__ + "img/collection-icon.4b60a1a5.svg";